import { gql } from '@apollo/client'

import { ModalLock } from '../modal-lock'
import { OneOfferLockContent } from '../one-offer-lock-content'
import {
  OneOfferLock_OfferLockDataFragment,
  OneOfferLock_ViewerFragment,
} from './__generated__/one-offer-lock.graphql'

export interface OneOfferLockProps {
  offerLockData: OneOfferLock_OfferLockDataFragment
  viewer: OneOfferLock_ViewerFragment
}

export function OneOfferLock({ offerLockData, viewer }: OneOfferLockProps) {
  return (
    <ModalLock size="sm" offerLockBody={offerLockData.body}>
      <OneOfferLockContent viewer={viewer} offerLockData={offerLockData} />
    </ModalLock>
  )
}

OneOfferLock.fragments = {
  offerLockData: gql`
    fragment OneOfferLock_offerLockData on OfferLockData {
      ...OneOfferLockContent_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${OneOfferLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment OneOfferLock_viewer on Profile {
      ...OneOfferLockContent_viewer
    }
    ${OneOfferLockContent.fragments.viewer}
  `,
}
